<div class="ig-location-filters">

    <mat-tab-group>
        <mat-tab label="Events"
                 [disabled]="isEventLocationFilterDisabled">
            <ng-template mat-tab-label>
                <mat-icon>event</mat-icon>
                Event Location Filter
                <span style="margin-left: 64px"
                      *ngIf="isEventLocationFilterDisabled">
                    <upgrade-button [show]="true" [css]="'upgrade-trip-planner'"></upgrade-button>
                </span>
            </ng-template>

            <div *ngIf="!isEventLocationFilterDisabled" class="panel">
                <div class="panel-header">
                    <h1>Event Location Filter</h1>
                </div>

                <mat-checkbox [(ngModel)]="eventIsCityLevelFilter"
                              style="margin-left: 32px;margin-bottom: 12px">
                    Use city level filter
                </mat-checkbox>
                <div style="font-size: 13px;margin:-10px 0 16px 32px">Using city level filtering will generate a
                    secondary menu with
                    cities as options in each group,
                    allowing events to be filtered by city in the group
                </div>

                <div class="flex relative space-around">
                    <div style="width: 38%;">
                        <div id="groups-area">
                            <div #accordionItem *ngFor="let group of clientEventGroups; let index = index">
                    <span class="group-area pointer" *ngIf="!group.isEditing" (click)="selectEventGroup(group)">
                        <mat-icon class="edit" (click)="enterEditMode(group)">edit</mat-icon>
                        <span class="title"
                              [ngStyle]="{'color':group.isSelected?'#41abf3':'rgba(0, 0, 0, 0.87)','fontWeight':group.isSelected?'bold':'normal'}">
                            {{ group.title }}
                        </span>
                        <mat-icon class="delete" (click)="showLocationWidgetUrl(group, 'events')"
                                  matTooltip="Get link">link</mat-icon>
                        <mat-icon class="red-text delete" (click)="removeEventGroup(group)"
                                  matTooltip="Delete this group">delete</mat-icon>
                    </span>
                                <div class="flex group-edit-box" *ngIf="group.isEditing">
                                    <ig-field label="Edit group name" icon="edit" [formControl]="form.get('tempTitle')"
                                              [(ngModel)]="group.tempTitle">
                                    </ig-field>
                                    <ig-button size="md" [isAsync]="false" (trigger)="updateGroupTitle(group)">save
                                    </ig-button>
                                    <ig-button size="md" color="cancel" (trigger)="cancelGroupTitle(group)">cancel
                                    </ig-button>
                                </div>
                            </div>
                            <div class="add-group pointer" (click)="addEventGroup()">+ group</div>
                        </div>
                    </div>
                    <div class="relative">
                        <mat-icon class="vertical-middle split-arrow">arrow_forward_ios</mat-icon>
                    </div>
                    <div id="cities-wrap">
                        <div *ngIf="!selectedEventGroup"
                             class="flex items-center justify-center gray-text full-width full-height">
                            Please select a group from left side
                        </div>
                        <ng-container *ngIf="selectedEventGroup">
                            <div *ngFor="let city of eventCities" class="m-b-1 city">
                    <span>
                        <mat-checkbox [name]="city" (change)="addCityToEventGroup($event, city)"
                                      [checked]="isCityInGroup(city, selectedEventGroup)">
                            {{ city }}
                        </mat-checkbox>
                    </span>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <ig-button size="md" [isAsync]="true" color="primary" (trigger)="saveEvent($event)">Save</ig-button>
            </div>
        </mat-tab>

        <mat-tab label="Place" [disabled]="!toggles.placeLocationFilter||!toggles.placeCalendar">
            <ng-template mat-tab-label>
                <mat-icon>room</mat-icon>
                Place Location Filter
                <span style="margin-left: 64px" *ngIf="!toggles.placeLocationFilter||!toggles.placeCalendar">
                    <upgrade-button [show]="true" [css]="'upgrade-trip-planner'"></upgrade-button>
                </span>
            </ng-template>

            <div *ngIf="toggles.placeLocationFilter&&toggles.placeCalendar" class="panel">
                <div class="panel-header">
                    <h1>Place Location Filter</h1>
                </div>

                <mat-checkbox [(ngModel)]="placeIsCityLevelFilter"
                              style="margin-left: 32px;margin-bottom: 12px">
                    Use city level filter
                </mat-checkbox>
                <div style="font-size: 13px;margin:-10px 0 16px 32px">Using city level filtering will generate a
                    secondary menu with
                    cities as options in each group,
                    allowing places to be filtered by city in the group
                </div>

                <div class="flex relative space-around">
                    <div style="width: 38%;">
                        <div id="groups-area">
                            <div #accordionItem *ngFor="let group of clientPlaceGroups; let index = index">
                    <span class="group-area pointer" *ngIf="!group.isEditing" (click)="selectPlaceGroup(group)">
                        <mat-icon class="edit" (click)="enterEditMode(group)">edit</mat-icon>
                        <span class="title"
                              [ngStyle]="{'color':group.isSelected?'#41abf3':'rgba(0, 0, 0, 0.87)','fontWeight':group.isSelected?'bold':'normal'}">
                            {{ group.title }}
                        </span>
                        <mat-icon class="delete" (click)="showLocationWidgetUrl(group, 'places')"
                                  matTooltip="Get link">link</mat-icon>
                        <mat-icon class="red-text delete" (click)="removePlaceGroup(group)"
                                  matTooltip="Delete this group">delete</mat-icon>
                    </span>
                                <div class="flex group-edit-box" *ngIf="group.isEditing">
                                    <ig-field label="Edit group name" icon="edit" [formControl]="form.get('tempTitle')"
                                              [(ngModel)]="group.tempTitle">
                                    </ig-field>
                                    <ig-button size="md" [isAsync]="false" (trigger)="updateGroupTitle(group)">save
                                    </ig-button>
                                    <ig-button size="md" color="cancel" (trigger)="cancelGroupTitle(group)">cancel
                                    </ig-button>
                                </div>
                            </div>
                            <div class="add-group pointer" (click)="addPlaceGroup()">+ group</div>
                        </div>
                    </div>
                    <div class="relative">
                        <mat-icon class="vertical-middle split-arrow">arrow_forward_ios</mat-icon>
                    </div>
                    <div id="cities-wrap">
                        <div *ngIf="!selectedPlaceGroup"
                             class="flex items-center justify-center gray-text full-width full-height">
                            Please select a group from left side
                        </div>
                        <ng-container *ngIf="selectedPlaceGroup">
                            <div *ngFor="let city of placeCities" class="m-b-1 city">
                    <span>
                        <mat-checkbox [name]="city" (change)="addCityToPlaceGroup($event, city)"
                                      [checked]="isCityInGroup(city, selectedPlaceGroup)">
                            {{ city }}
                        </mat-checkbox>
                    </span>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <ig-button size="md" [isAsync]="true" color="primary" (trigger)="save($event)">Save</ig-button>
            </div>
        </mat-tab>
    </mat-tab-group>


</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/customization/location.filter.settings/location.filter.settings.component.html